import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { UPDATE_KITCHEN_TICKET, GET_KITCHEN_TICKET } from './constants';

export const updateKitchenTicket = extendRoutine(createRoutine(UPDATE_KITCHEN_TICKET), 'RESET');
export const getKitchenTicket = extendRoutine(createRoutine(GET_KITCHEN_TICKET), 'RESET');
